export default __webpack_public_path__ + "static/media/gallery-img-7.da2baa66.jpg";